import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "fullcalendar/dist/fullcalendar.css";
import config from "./config/constants";
import "animate.css";
import { library } from "@fortawesome/fontawesome-svg-core";

import ClickOutside from "./directives/v-click-outside";
Vue.directive("click-outside", ClickOutside);

import VueConfetti from 'vue-confetti';
Vue.use(VueConfetti)

import {
  faTimesCircle,
  faTimes,
  faClock,
  faUserClock,
  faMapMarkerAlt,
  faUser,
  faEuroSign,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faBars,
  faEllipsisH,
  faPlay,
  faCheck,
  faLock,
  faEye,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-pro/css/all.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "slick-carousel/slick/slick.css";
import VueDateFns from "vue-date-fns";
import IdleVue from "idle-vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";
import * as SentryBrowser from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  Vue,
  dsn: "https://d7fd57f791e24de5a5a1a54f13348ed1@sentry.spectrum.life/70",
  release: process.env.VUE_APP_VERSION,
  environment: process.env.NODE_ENV,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "spectrum.life", "surge-qa.com", /^\//],
    }),
    // SentryBrowser.captureConsoleIntegration() // this doesnt want to work : integration.js:52 Uncaught TypeError: integration.setupOnce is not a function
  ],
  tracesSampleRate: 1.0,
});

// Vue.use(VueGtag, {
//   config: { id: process.env.VUE_APP_GA_TRACKING_ID },
//   appName: 'UP-SPA',
// }, router);

Vue.component("v-select", vSelect);

const eventsHub = new Vue();
const options = { eventEmitter: eventsHub, idleTime: 7200000 };


Vue.use(IdleVue, options);

Vue.use(VueDateFns);
library.add(
  faTimesCircle,
  faTimes,
  faClock,
  faUserClock,
  faMapMarkerAlt,
  faUser,
  faEuroSign,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faBars,
  faEllipsisH,
  faPlay,
  faCheck,
  faLock,
  faEye,
  faEyeSlash
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(BootstrapVue);

axios.defaults.headers.common['Content-type'] = 'application/x-www-form-urlencoded; charset=utf-8';

Vue.use(VueAxios, axios);
Vue.use(config);

Vue.config.productionTip = false;

import './mixins/generalMixin'

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");
